'use client';

import { useTranslations } from 'next-intl';
import { ArrowDown01Icon, ArrowRight01Icon } from '@terra/ui-icons';
import { IconButton } from '../../components/icon-button';

export type GroupToggleButtonProps = {
  groupKey: string;
  isCollapsed: boolean;
  onToggle: (groupKey: string) => void;
};

export function GroupToggleButton({
  groupKey,
  isCollapsed,
  onToggle,
}: GroupToggleButtonProps) {
  const t = useTranslations('designSystem.groupBy');

  return (
    <IconButton
      size="xs"
      variant="ghost"
      aria-label={isCollapsed ? t('expandGroup') : t('collapseGroup')}
      stopPropagation
      onClick={() => onToggle(groupKey)}
    >
      {isCollapsed ? (
        <ArrowRight01Icon size={14} />
      ) : (
        <ArrowDown01Icon size={14} />
      )}
    </IconButton>
  );
}
